import './style.css';

import i18nService from '../../services/i18nService';

export default function Navigation(props) {
  const watch = (props.selectedColor || {}).variantId
  const strap = (props.selectedStrap || {}).variantId
  const kit = (props.selectedCase || {}).variantId
  const checkoutUrl = `https://milus.com/cart/${watch}:1,${strap}:1,${kit}:1?discount=PERSONALMILUS`

  let conditionalSixthStep;
  if (props.step >= 5) {
    conditionalSixthStep = (
      <a className='Navigation-bullet Navigation-bullet--special' href={checkoutUrl}>
        <span className="Navigation-step">6</span>
        <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.order')}</span>
      </a>
    )
  }

  return (
    <div className="Navigation">
      <h1 className="Navigation-title">{i18nService.i18n(props.locale, `steps.${props.step}`)}</h1>
      <div className={`Navigation-progress Navigation-progress--${props.step}`}>
        <div className={props.step >= 1 ? 'Navigation-bullet Navigation-bullet--active' : 'Navigation-bullet'} onClick={e => props.setStep(1)}>
          <span className="Navigation-step">1</span>
          <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.model')}</span>
        </div>

        <div className={props.step >= 2 ? 'Navigation-bullet Navigation-bullet--active' : 'Navigation-bullet'} onClick={e => props.setStep(2)}>
          <span className="Navigation-step">2</span>
          <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.color')}</span>
        </div>

        <div className={props.step >= 3 ? 'Navigation-bullet Navigation-bullet--active' : 'Navigation-bullet'} onClick={e => props.setStep(3)}>
          <span className="Navigation-step">3</span>
          <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.strap')}</span>
        </div>

        <div className={props.step >= 4 ? 'Navigation-bullet Navigation-bullet--active' : 'Navigation-bullet'} onClick={e => props.setStep(4)}>
          <span className="Navigation-step">4</span>
          <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.case')}</span>
        </div>

        <div className={props.step >= 5 ? 'Navigation-bullet Navigation-bullet--active' : 'Navigation-bullet'} onClick={e => props.setStep(5)}>
          <span className="Navigation-step">5</span>
          <span className="Navigation-label">{i18nService.i18n(props.locale, 'navigation.review')}</span>
        </div>

        {conditionalSixthStep}
      </div>
    </div>
  )
}
